<template>
    <div>
        <a
            :style="{color: color}"
            class="sponsor-btn shadow-text-none cursor-pointer block"
            @click.prevent="onClickTitle"
            v-html="title">
        </a>
        <span
            :style="{color: color}"
            class="shadow-text-none font-size-16"
            v-html="message"></span>
    </div>
</template>

<script>
export default {
    name: 'ShareSponsorQuizBox',

    props: {
        title: {
            type: String
        },

        message: {
            type: String
        },

        color: {
            type: String
        }
    },

    methods: {
        onClickTitle () {
            this.$emit('click-title')
        }
    }
}
</script>
